export const SHOP_STATE_KEY = '@shop';

export const ON_FETCH_START = `${SHOP_STATE_KEY}/ON_FETCH_START`;
export const ON_FETCH_FAILURE = `${SHOP_STATE_KEY}/ON_FETCH_FAILURE`;

export const ON_FULFILLMENT_OFFERINGS_SUCCESS = `${SHOP_STATE_KEY}/ON_FULFILLMENT_OFFERINGS_SUCCESS`;

export const CARTS_MERGED = `${SHOP_STATE_KEY}/CARTS_MERGED`;
